import React, { useState } from 'react'
import styled from 'styled-components'
import { Colors, Color } from '../styles/Colors';
import HideIcon from './icons/HideIcon';
import ShowIcon from './icons/ShowIcon';
import { useTranslation } from 'react-i18next';

const IsOpenBtn = styled.button`
    grid-column: 1 / -1; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    background-color: ${Color(Colors.blue)}; 
    width: 100%; 
    height: 38px;
    border-radius: 4px; 
    border: none; 
    margin: 1.5rem 0 0 0; 
    padding: 0.5rem 1rem 0.5rem 1rem; 

    & > span {
        display: flex; 
        justify-content: center; 
        align-items: center; 

        & > svg {
            height: 28px; 
            width: 28px; 
            fill: ${Color(Colors.white)};
        }

        & > p {
            color: ${Color(Colors.white)};
            margin: 0 0 0 0.5rem; 
        }
    }
    
    &:hover {
        background-color: ${Color(Colors.lightBlue)}; 
        cursor: pointer; 
    }

`;

const FormContainer = styled.div` 
    opacity: ${({$isOpen}) => $isOpen ? '1' : '0'}; 
    max-height: ${({$isOpen}) => $isOpen ? '1200px' : '0'}; 
    margin: ${({$isOpen}) => $isOpen ? '1rem 0 0 0' : '0'};
    box-shadow: ${({$isOpen}) => $isOpen ? '8px 8px 8px rgba(0, 0, 0, 0.3)' : '0'}; 
    overflow: hidden;
    background-color: ${Color(Colors.blue)}; 
    transition: opacity 400ms ease-out, max-height 400ms ease-out, margin 400ms ease-out,  box-shadow 400ms ease-out; 
    border-radius: 4px;
`;

const ToggleForm = ({ children }) => {
    const { t } = useTranslation(); 
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div style={{gridColumn: '1 / -1' }}>
            <IsOpenBtn onClick={() => setIsOpen(!isOpen)}>
                {isOpen === false
                    ?
                    <span>
                        <ShowIcon /> 
                        <p>{`${t('common.showSection')} ${t('common.inputField')}`}</p>
                    </span>
                    :
                    <span>
                        <HideIcon />
                        <p>{`${t('common.hideSection')} ${t('common.inputField')}`}</p>
                    </span>
                }
            </IsOpenBtn>
            <FormContainer $isOpen={isOpen}>{children}</FormContainer>
        </div>
    )
}

export default ToggleForm